(ns frontend.view.settings2.reporting-db.event
  (:require
   [re-frame.core :as rf]
   [frontend.controller.websocket.event :as ws]
   [frontend.view.settings2.reporting-db.sub :as sub]))

(rf/reg-event-fx
 ::new-password-input
 (fn [{db :db} [_ new-pw]]
   {:db (assoc db ::sub/new-password new-pw)}))

(rf/reg-event-fx
 ::current-password-input
 (fn [{db :db} [_ edited-value]]
   {:db (assoc db ::sub/current-password edited-value)}))

(rf/reg-event-fx
 ::reset-password!-ok
 (fn [{db :db} [_ resp]]
   {:db (-> db
            (dissoc ::sub/processing)
            (dissoc ::sub/new-password))}))

(rf/reg-event-fx
 ::reset-password!-failed
 (fn [{db :db} [_ resp]]
   (js/console.error "Failed to reset reporting db password " resp)
   {:db (-> db
            (dissoc ::sub/processing))}))

(rf/reg-event-fx
 ::reset-password!
 (fn [{db :db} [_ new-password]]
   {:db       (-> db
                  (assoc-in [::sub/processing] true))
    ::ws/send {:id         :reporting-db/reset-password
               :body       {:new-password new-password}
               :on-success [::reset-password!-ok]
               :on-error   [::reset-password!-failed]}}
 ))
